import { axios, createFormData, handleError } from '../axios';

export const adminChangeMemberStatus = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post('admin/member/edit/', createFormData(data))
      .then((response) => {
        try {
          resolve(response.data);
        } catch (e) {
          console.error(e.message);
        }
      })
      .catch((e) => {
        handleError(e);
      });
  });
};
